const textProps = {
  copyright: {
    children: " AG + Énergies ",
    href: "https://www.agplus-energies.fr/",
    target: "_blank",
  },
  
};
export default textProps;
